// const StyleLintPlugin = require('stylelint-webpack-plugin');
module.exports = {
    publicPath: '/',
    css: {
        loaderOptions: {
            // by default the `sass` option will apply to both syntaxes
            // because `scss` syntax is also processed by sass-loader underlyingly
            // but when configuring the `data` option
            // `scss` syntax requires an semicolon at the end of a statement, while `sass` syntax requires none
            // in that case, we can target the `scss` syntax separately using the `scss` option
            // scss: {
            //     prependData: `@import "@/scss/variables.scss";`
            // }
        }
    },
    // configureWebpack: {
    //     plugins: [
    //         new StyleLintPlugin({
    //             files: ['**/*.{vue,htm,html,css,sss,less,scss,sass}'],
    //         })
    //     ],
    // },
    chainWebpack: config => {
        config.plugin('prefetch').tap(options => {
            options[0].as = (entry) => {
                if (/\.css$/.test(entry)) return 'style'
                if (/\.woff$/.test(entry)) return 'font'
                if (/\.png$/.test(entry)) return 'image'
                if (/\.jpg$/.test(entry)) return 'image'
                return 'script'
            }
            options[0].include = 'allAssets'
            // options[0].fileWhitelist: [/\.files/, /\.to/, /\.include/]
            // options[0].fileBlacklist: [/\.files/, /\.to/, /\.exclude/]
            return options
        })
    }
}
